import { compile } from "path-to-regexp";
import { MultipartUploadParams } from "../../store/actions/fileVersions";
import { FileVersion } from "../../store/models/fileVersion";
import {
  makeBackendGetCallWithJsonResponse,
  makeBackendPostCallWithJsonResponse,
} from "../../store/utils/fetch";
import { RELEASE_TRACK_FILE_VERSION } from "../../store/utils/routes";
import { promiseEngineEarsHandler } from "../helpers";

export interface MarkArchived {
  mark_archived: boolean;
}

export const markReleaseTrackFileAsUploadedAPI = async (
  fileVersionId: number,
  args?: MultipartUploadParams | MarkArchived,
) => {
  const route = compile(RELEASE_TRACK_FILE_VERSION)({
    file_version_id: fileVersionId,
  });
  return makeBackendPostCallWithJsonResponse<FileVersion>(
    route,
    args || {},
  ).then(promiseEngineEarsHandler);
};

export const getReleaseTrackFileVersionURLAPI = async (
  fileVersionId: number,
) => {
  const route = compile(RELEASE_TRACK_FILE_VERSION)({
    file_version_id: fileVersionId,
  });
  return makeBackendGetCallWithJsonResponse<{ url: string | undefined }>(
    route,
    "",
  ).then(promiseEngineEarsHandler);
};
